// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1uKpO","buttons":"PendingPaymentAlert_buttons__1ric5"};